import { formatNumberAsCurrency, formatNumberLocalized } from './formatters';

// TODO: refactor
export const getNumberWithSymbol = (price: number, tokenSymbol = 'USDT', isSymbolLast = false) => {
  if (tokenSymbol.toLowerCase() === 'usdt') {
    return formatNumberAsCurrency({ amount: price, maximumFractionDigits: 4 });
  }

  const formattedPrice = formatNumberLocalized(price, { options: { maximumFractionDigits: 4 } });

  return isSymbolLast ? `${formattedPrice} ${tokenSymbol}` : `${tokenSymbol} ${formattedPrice}`;
};
